<script setup>
import { onMounted, computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useGlobalStore } from "@stores/global.js";

import axios from "axios";
import Purchase from "@/sections/product/Purchase.vue";
import SimilarProducts from "@/sections/product/SimilarProducts.vue";
import Faqs from "@/sections/product/Faqs.vue";
import Loading from "@/components/icons/Loading.vue";

const global = useGlobalStore();
const route = useRoute();

const product = ref(null);
const loading = ref(true);
const error = ref(null);

function getProduct() {
	loading.value = true;
	product.value = {};
	axios
		.get(`/api/shopify/product/${route.params.slug}`)
		.then((p) => {
			product.value = p.data;

			if (product.value.theme) {
				global.setTheme(
					product.value.theme.background,
					product.value.theme.accent,
					product.value.theme.surface,
				);
			} else {
				console.log(`Product "${product.value.title}" has no theme set.`);
			}

			loading.value = false;
		})
		.catch((e) => {
			console.log(e);
		});
}

getProduct();
</script>

<template>
	<div
		v-if="loading"
		class="bg-theme text-theme flex h-[calc(100dvh-var(--header-height))] items-center justify-center"
	>
		<Loading class="size-20 animate-spin" />
	</div>
	<div v-else class="pt-32">
		<Purchase :product="product" />
		<SimilarProducts
			:related_products="product.related_products"
			:parent_collection="product.parent_collection"
			v-if="product.related_products.length > 0"
		/>
		<Faqs :faqs="product.faqs" />
	</div>
</template>
